import { render } from "./CompetitionRoundSizes.vue?vue&type=template&id=86dccc64&scoped=true"
import script from "./CompetitionRoundSizes.vue?vue&type=script&lang=js"
export * from "./CompetitionRoundSizes.vue?vue&type=script&lang=js"

import "./CompetitionRoundSizes.vue?vue&type=style&index=0&id=86dccc64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86dccc64"]])

export default __exports__